// Get the correct API base URL based on environment
export const getApiBaseUrl = (): string => {
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:3000";
  }
  // Production: handled by Vercel rewrites
  return "";
};

// Helper function to make API calls with correct base URL
export const apiCall = async (endpoint: string, options?: RequestInit) => {
  const baseUrl = getApiBaseUrl();
  const url = `${baseUrl}${endpoint}`;
  return fetch(url, {
    credentials: "include", // Include cookies for session management
    ...options,
  });
};
